import { Input,
         OnInit,
         Component,
         ViewChild,
         ElementRef } from '@angular/core';
import { FormGroup }  from '@angular/forms';
import { IngTinyMce } from '../../inputs';

@Component({
  selector: 'ing-tiny-mce',
  templateUrl: './tiny-mce.component.html',
  styleUrls: ['./tiny-mce.component.scss']
})
export class TinyMceComponent implements OnInit {
  @ViewChild('summernote') summernote: ElementRef;

  @Input() form:  FormGroup;
  @Input() input: IngTinyMce;

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-tinymce';

    $(this.summernote.nativeElement).summernote({
        height: this.input.height,
        dialogsInBody: true,
        callbacks: {
            onChange: (contents, $editable) => {
                this.form.controls[this.input.key].setValue(contents);
            }
        }
    });

    $(this.summernote.nativeElement).summernote('code', this.form.controls[this.input.key].value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/tiny-mce/tiny-mce.component.ts